/*
 * @Author: Teemo Ding
 * @Date: 2021-06-22 14:28:24
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 10:39:37
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/DeveloperSetting/config.tsx
 */
import React from 'react';
import css from './css.less';
import {
  handleOnFormatStoreTimeAndDateWithTimezone,
  handleOnGetStoreTimezoneUTC,
} from '@/src/tools/tools';

const breadcrumbData = ({ getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/settings',
    name: getI18n('general.sider.settings'),
  },
  {
    url: '',
    name: getI18n('settings.list.developerSetting'),
  },
];

const columns = (deleteAccessKey, disableDelete, { getI18n }) => [
  {
    title: getI18n('general.title'),
    dataIndex: 'title',
    default: true,
    optional: true,
    key: 'title',
    className: css.columnClass,
    minWidth: 192,
  },
  {
    title: getI18n('storeDeveloperSetting.detail.accessKeyID'),
    dataIndex: 'accessKey',
    default: true,
    optional: true,
    key: 'accessKey',
    className: css.columnClass,
    minWidth: 280,
  },
  {
    title: `${getI18n(
      'general.created',
    )} (UTC ${handleOnGetStoreTimezoneUTC()}) `, //(GMT +11)
    dataIndex: 'createdDate',
    default: true,
    optional: true,
    key: 'createdDate',
    className: css.columnClass,
    minWidth: 160,
    childGenerate: (text) => {
      const t = handleOnFormatStoreTimeAndDateWithTimezone(text);
      return t;
    },
  },
  {
    title: `${getI18n('general.uRL')} `,
    dataIndex: 'entryPoint',
    default: true,
    optional: true,
    key: 'entryPoint',
    className: css.columnClass,
    minWidth: 330,
  },

  disableDelete
    ? {}
    : {
        title: getI18n(
          'general.advancedFilters.commonStoreProductsWithTable.actions',
        ),
        dataIndex: 'actions',
        default: true,
        optional: true,
        key: 'actions',
        className: css.columnClass,
        minWidth: 128,
        childGenerate: (text, record) => (
          <div
            className={css.delete}
            onClick={() => {
              deleteAccessKey(record);
            }}>
            {getI18n('general.delete')}
          </div>
        ),
      },
];
export { breadcrumbData, columns };
